function etxSwiper() {
  console.log("etxSwiper initialised");

  const sliders = [
    {
      selector: ".LinkCardSlider",
      config: {
        direction: "horizontal",
        slidesPerView: 1.35,
        spaceBetween: 20,
        resizeObserver: true,
        centeredSlides: false,
        updateOnWindowResize: true,
        breakpoints: {
          560: {
            slidesPerView: 2,
          },
        },
      },
    },
    {
      selector: ".SwiperTeasers:not(.small):not(.centered)",
      controls: true,
      config: {
        direction: "horizontal",
        autoplay: false,
        autoHeight: true,
        loop: false,
        watchOverflow: true,
        slideToClickedSlide: false,
        simulateTouch: true,
        breakpoints: {
          0: { slidesPerView: 1, slidesPerGroup: 1 },
          520: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 20 },
          1000: { slidesPerView: 2.5, slidesPerGroup: 2, spaceBetween: 20 },
          1200: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 20 },
        },
      },
    },
    {
      selector: ".SwiperTeasers:not(.small).centered",
      controls: true,
      config: {
        direction: "horizontal",
        autoplay: false,
        autoHeight: true,
        loop: false,
        watchOverflow: true,
        slideToClickedSlide: false,
        simulateTouch: true,
        breakpoints: {
          0: { slidesPerView: 1, slidesPerGroup: 1 },
          520: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 20 },
        },
      },
    },
    {
      selector: ".SwiperTeasers.small:not(.centered)",
      controls: true,
      config: {
        direction: "horizontal",
        autoplay: false,
        autoHeight: true,
        loop: false,
        watchOverflow: true,
        slideToClickedSlide: false,
        simulateTouch: true,
        breakpoints: {
          0: { slidesPerView: 1, slidesPerGroup: 1 },
          520: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 20 },
          1000: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 20 },
          1200: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 20 },
        },
      },
    },
    {
      selector: ".SwiperAmbassadors",
      controls: true,
      config: {
        direction: "horizontal",
        autoplay: false,
        autoHeight: true,
        loop: true,
        watchOverflow: true,
        slideToClickedSlide: true,
        simulateTouch: true,
        breakpoints: {
          0: { slidesPerView: 1, slidesPerGroup: 1 },
        },
        pagination: {
          type: "fraction",
        },
        on: {
          slideChange: function () {
            let parentSwiper = this.el.closest(".SwiperAmbassadors");

            let swiperBackground = parentSwiper.querySelector(".Swiper__background");

            let activeSlide = this.slides[this.activeIndex];
            if (!activeSlide) return;

            console.log(activeSlide.dataset.brandColor);

            let backgroundColorClass =
              activeSlide.dataset.brandColor || "background-color-black";

            if (swiperBackground) {
              swiperBackground.className = "Swiper__background " + backgroundColorClass;
            }
          },
        },
      },
    },
    {
      selector: ".SwiperCrossSelling",
      meta: true,
      config: {
        spaceBetween: 20,
        loop: true,
        breakpoints: {
          0: {
            slidesPerView: 1.25,
            slidesPerGroup: 1,
          },
          400: {
            slidesPerView: 1.75,
            slidesPerGroup: 1,
          },
          560: {
            slidesPerView: 2.15,
            slidesPerGroup: 2,
          },
          768: {
            slidesPerView: 2.75,
            slidesPerGroup: 2,
          },
          1000: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          1500: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
        },
      },
    },
    {
      selector: ".SwiperMainProduct__images",
      controls: true,
      config: {
        direction: "horizontal",
        autoplay: false,
        autoHeight: true,
        loop: true,
        simulateTouch: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
      thumbs: {
        selector: ".SwiperMainProduct__thumbs",
        config: {
          direction: "horizontal",
          autoplay: false,
          spaceBetween: 10,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
          breakpoints: {
            0: { slidesPerView: 3 },
            1000: { slidesPerView: 4 },
            1200: { slidesPerView: 5 },
          },
        },
      },
    },
    {
      selector: ".SwiperProducts__images",
      controls: true,
      config: {
        direction: "horizontal",
        centeredSlides: true,
        watchOverflow: true,
        slideToClickedSlide: true,
        simulateTouch: true,
        effect: "creative",
        creativeEffect: {
          limitProgress: 10,
          prev: {
            rotate: [0, 0, -3],
            translate: ["-110%", "8.25%", 0],
            scale: "0.9",
            origin: "center bottom",
          },
          next: {
            rotate: [0, 0, 3],
            translate: ["110%", "8.25%", 0],
            scale: "0.9",
            origin: "center bottom",
          },
        },
        breakpoints: {
          0: { slidesPerView: 1.5, slidesPerGroup: 1 },
          768: { slidesPerView: 2, slidesPerGroup: 1, spaceBetween: 20 },
        },
        on: {
          slideChange: function () {
            let parentContainer = this.el.closest(".Container");
            let parentSwiper = this.el.closest(".SwiperProducts__images");
            if (!parentContainer || !parentSwiper) return;

            let containerBackground = parentContainer.querySelector(".Container__background");
            let brandStripes = parentSwiper.querySelector(".BrandStripes");
            if (!brandStripes) return;

            let activeSlide = this.slides[this.activeIndex];
            if (!activeSlide) return;

            let backgroundColorClass = activeSlide.dataset.brandColor || "background-color-black";

            let brandstripesVariation = activeSlide.dataset.brandstripesVariation || "1";
            let brandstripesColors = activeSlide.dataset.brandstripesColors
              ? activeSlide.dataset.brandstripesColors.split(",")
              : ["transparent", "transparent", "transparent", "transparent"];

            if (containerBackground) {
              containerBackground.className = "Container__background " + backgroundColorClass;
            }

            brandStripes.dataset.brandstripesVariation = brandstripesVariation;

            const items = brandStripes.querySelectorAll(".BrandStripes__lines__item");
            brandstripesColors.forEach((color, index) => {
              if (!items[index]) return;
              items[index].style.removeProperty("--brandstripe-color");
              items[index].style.setProperty("--brandstripe-color", color);
            });
          },
        },
      },
      thumbs: {
        selector: ".SwiperProducts__content",
        config: {
          direction: "horizontal",
          autoplay: false,
        },
      },
    },
    {
      selector: ".SwiperIngredients__images",
      config: {
        direction: "horizontal",
        centeredSlides: true,
        watchOverflow: true,
        slideToClickedSlide: true,
        simulateTouch: true,
        effect: "creative",
        creativeEffect: {
          limitProgress: 10,
          prev: {
            rotate: [0, 0, -3],
            translate: ["-110%", "8.25%", 0],
            scale: "0.9",
            origin: "center bottom",
          },
          next: {
            rotate: [0, 0, 3],
            translate: ["110%", "8.25%", 0],
            scale: "0.9",
            origin: "center bottom",
          },
        },
        breakpoints: {
          0: { slidesPerView: 1.5, slidesPerGroup: 1 },
          768: { slidesPerView: 2, slidesPerGroup: 1, spaceBetween: 20 },
        },
      },
      thumbs: {
        selector: ".SwiperIngredients__content",
        config: {
          direction: "horizontal",
          autoplay: false,
        },
      },
    },
    {
      selector: ".SwiperComboGalleryImages",
      controls: true,
      config: {
        direction: "horizontal",
        autoplay: false,
        spaceBetween: 20,
        loopAdditionalSlides: 4,
        watchOverflow: true,
        simulateTouch: true,
        breakpoints: {
          0: { slidesPerView: 1, slidesPerGroup: 1 },
          650: { slidesPerView: 2, slidesPerGroup: 2 },
          1000: { slidesPerView: 3, slidesPerGroup: 3 },
        },
      },
    },
    {
      selector: ".SwiperPublications",
      controls: true,
      config: {
        direction: "horizontal",
        autoplay: true,
        spaceBetween: 20,
        slidesPerGroup: 1,
        loop: true,
        loopAdditionalSlides: 4,
        watchOverflow: true,
        simulateTouch: true,
        pagination: { dynamicBullets: true },
        breakpoints: {
          0: { slidesPerView: 2 },
          520: { slidesPerView: 3 },
          650: { slidesPerView: 4 },
          1000: { slidesPerView: 5 },
        },
      },
    },
    {
      selector: ".SwiperUSPs",
      controls: true,
      config: {
        direction: "horizontal",
        autoplay: false,
        spaceBetween: 20,
        slidesPerGroup: 1,
        loop: false,
        watchOverflow: true,
        simulateTouch: true,
        breakpoints: {
          0: { slidesPerView: 1.5 },
          520: { slidesPerView: 2 },
          650: { slidesPerView: 3 },
          1000: { slidesPerView: 4 },
        },
      },
    },
    {
      selector: ".SwiperUSPsCompact",
      controls: true,
      config: {
        direction: "horizontal",
        autoplay: false,
        spaceBetween: 20,
        slidesPerGroup: 1,
        loop: false,
        watchOverflow: true,
        simulateTouch: true,
        breakpoints: {
          0: { slidesPerView: 1.5 },
          520: { slidesPerView: 2 },
          1000: { slidesPerView: 3 },
          1200: { slidesPerView: 2 },
        },
      },
    },
  ];

  const baseConfig = {
    resizeObserver: true,
    observeParents: true,
    observer: true,
    updateOnWindowResize: true,
    watchOverflow: true,
  };

  sliders.forEach(({ selector, config, meta, controls, thumbs }) => {
    document.querySelectorAll(selector).forEach((el) => {
      let mainSwiper;
      let thumbsSwiper;
    
      // Vorhandene Instanzen zuerst destroyen
      if (el.swiper && !el.swiper.destroyed) {
        el.swiper.destroy(true, true);
      }
      
      const mergedConfig = { ...baseConfig, ...config };

      if (meta) {
        const id = el.getAttribute("data-swiper-id");
        const metaContainer = document.querySelector(`.Swiper__controls[data-swiper-id="${id}"]`);

        if (metaContainer) {
          const pag = metaContainer.querySelector(".swiper-pagination");
          if (pag) {
            mergedConfig.pagination = {
              ...(mergedConfig.pagination || {}),
              el: pag,
              clickable: true,
              type: "bullets",
            };
          }

          const prev = metaContainer.querySelector(".swiperArrowPrev");
          const next = metaContainer.querySelector(".swiperArrowNext");

          if (prev && next) {
            mergedConfig.navigation = {
              prevEl: prev,
              nextEl: next,
            };
          }
        }
      }

      if (controls) {
        const id = el.getAttribute("data-swiper-id");
        const controlsEl = document.querySelector(`.Swiper__controls[data-swiper-id="${id}"]`);
        if (controlsEl) {
          const pag = controlsEl.querySelector(".Swiper__controls__pagination");
          if (pag) {
            mergedConfig.pagination = {
              type: "bullets",
              clickable: true,
              ...(mergedConfig.pagination || {}),
              el: pag,
            };
          }
        }
      }

      if (thumbs) {
        const parent = el.parentElement;
        const thumbsEl = parent ? parent.querySelector(thumbs.selector) : null;

        if (thumbsEl) {
          thumbsSwiper = new Swiper(thumbsEl, { ...baseConfig, ...thumbs.config });
          mergedConfig.thumbs = { swiper: thumbsSwiper };
        }
      }

      mainSwiper = new Swiper(el, mergedConfig);

      // Bidirectional sync only for SwiperProducts__images
      if (selector === ".SwiperProducts__images" && thumbsSwiper) {
        thumbsSwiper.on("slideChange", () => {
          if (!mainSwiper) return;

          if (typeof mainSwiper.slideToLoop === "function" && mainSwiper.params.loop) {
            mainSwiper.slideToLoop(thumbsSwiper.activeIndex);
          } else {
            mainSwiper.slideTo(thumbsSwiper.activeIndex);
          }
        });
      }
    });
  });
}